import * as validators from './formValidators';

export const validateLogInForm = (values) => {
    let errors = {};
    const username = values['Email'];
    const password = values['Password'];

    let error = validators.validateRequired(username, 'Email');
    if (validators.isEmptyObject(error)) {
        error = validators.validateEmail(username, 'Email');
    }

    errors = { ...errors, ...error };
    error = validators.validateRequired(password, 'Password');
    errors = { ...errors, ...error };
    return errors;
};

export const validateResetPasswordForm = (values) => {
    return validateLogInForm(values);
};

export const validateEmailForm = (values) => {
    const errors = {};
    const username = values['Email'];

    let error = validators.validateRequired(username, 'Email');
    if (validators.isEmptyObject(error)) {
        error = validators.validateEmail(username, 'Email');
    }
    return errors;
};
